import React from 'react'
type Props = {
    zoneData?: any,
    mrData?: any,
    title?: string
    titleColor?: string
}
const CardView = ({
    zoneData,
    mrData,
    title,
    titleColor,
}: Props) => {
    return (
        <>
            <div className='card' style={{ backgroundColor: '#FFFFFF', padding: '10px', marginBottom: '10px' }} >
                <div className={`fw-bold fs-2 mb-2 mt-5`} style={{ color: titleColor, paddingLeft: '10px' }} >{title}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyItems: 'space-between', padding: '10px', justifyContent: 'space-between' }} >
                    <div className='card-view' style={{ width: '280px', height: '120px', backgroundColor: '#F7F9FA', borderRadius: '10px', marginBottom: '10px', padding: '20px' , overflow:'scroll' }} >
                        <span style={{ color: '#5B5B5B', fontFamily: 'Poppins', fontWeight: '700' }} >Top Zone</span><br />
                        <span style={{ color: '#15B8CB', fontFamily: 'Poppins', fontSize: '1.8rem', fontWeight: '600' }} >{zoneData?.zone_name}</span>
                    </div>
                    <div className='card-view' style={{ width: '280px', height: '120px', padding: '20px', backgroundColor: '#F7F9FA', borderRadius: '10px',overflow:'scroll' }} >
                        <span style={{ color: '#5B5B5B', fontFamily: 'Poppins', fontWeight: '700' }}>Top MR (Over All)</span><br />
                        <span style={{ color: '#15B8CB', fontFamily: 'Poppins', fontSize: '1.8rem', fontWeight: '600' }} >{mrData?.mr_name}</span><br />
                        <span style={{ color: '#5B5B5B', fontFamily: 'Poppins', fontWeight: '400' }}>{mrData?.zone_name}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CardView